import { render, staticRenderFns } from "./ClinicalWidget.vue?vue&type=template&id=e5eea7c0"
import script from "./ClinicalWidget.vue?vue&type=script&lang=js"
export * from "./ClinicalWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports